import { useState, useEffect } from 'react';
import {
  fetchUsersList,
  validateUserPassKey,
} from '../../../../core/database/user/multiUserStorage';
import { UserMetaData } from '../../../../core/redux/auth/authTypes';
import { ResultWithOptionalError } from '../../../../core/types/generic/results';
import { saveUserMetaDataLS } from '../../../../core/utils/auth/authUtils';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../core/hooks/storeHooks';
import { logoutUser } from '../../../../core/redux/auth/thunks/user';

interface UsersState {
  loading: boolean;
  users: UserMetaData[];
  filterText: string;
  selectedUser?: UserMetaData;
  validationModalOpen: boolean;
}

const initialState = {
  loading: false,
  users: [],
  filterText: '',
  validationModalOpen: false,
};

export interface UsersListDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  activeUserId: string;
  canCreateNewUser?: boolean;
}

export default ({ isOpen, activeUserId }: UsersListDrawerProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState<UsersState>(initialState);

  useEffect(() => {
    const fetch = async () => {
      if (isOpen) {
        setState({
          ...state,
          loading: true,
        });
        try {
          const results: ResultWithOptionalError<UserMetaData[]> =
            await fetchUsersList();
          if (results.data) {
            setState({
              ...state,
              users: results.data,
              loading: false,
            });
          }
        } catch {
          setState({ ...state, loading: false });
        }
      } else {
        setState(initialState);
      }
    };
    fetch();
  }, [isOpen]);

  const setFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filterText = e.target.value;
    setState({
      ...state,
      filterText,
    });
  };

  const navigateAuth = () => navigate('/auth');

  const startLoginUser = async (userMetaData: UserMetaData) => {
    if (activeUserId) {
      dispatch(
        logoutUser({
          navigateAuth,
          newUserMetaData: userMetaData,
        })
      );
    } else {
      saveUserMetaDataLS(userMetaData);
      navigate('/auth');
    }

    // const result: ResultWithOptionalError<CryptoKey> =
    //   await validateUserPassKey(userMetaData.id, userMetaData.id);

    // if (result.error) {
    //   return setState({
    //     ...state,
    //     selectedUser: userMetaData,
    //     validationModalOpen: true,
    //   });
    // }

    // if (result.data) {
    //   const privateKey = result.data;
    //   //   Permissi
    // }
  };

  //   const onPassKeyValidation = async () => {
  //     if (
  //         appConfigs?.localBackups ||
  //         appConfigs?.primaryStorage === PrimaryStorage.FileSystem
  //       ) {
  //         const result: ResultWithOptionalError<FileSystemDirectoryHandle> =
  //           await loadAndGetDirectoryPermission();

  //         if (result.error) return;
  //         dirHandler = result.data;
  //       }

  //   }

  return {
    state,
    setFilterText,
    startLoginUser,
  };
};
